// frontend/src/components/ProductBlock.js
//
// "What is Greatly Social?" — used on the support articles and anywhere else a
// reader arrives for a problem rather than for the product.
//
// Placed AFTER the fix, deliberately. Someone landing on an Instagram error is
// mid-problem: answer their question first, introduce the product second. A
// product pitch above the answer costs the trust that makes the pitch work.
//
// Every claim is verified in the codebase — see the note in
// data/platform-schedulers.json. Keep this list and the platform pages' feature
// grid in step; they describe the same product.

import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import { CheckCircleFill } from 'react-bootstrap-icons'

export const PRODUCT_FEATURES = [
  ['Eight networks, one post', 'Instagram, Facebook, Threads, X, LinkedIn, TikTok, Pinterest and YouTube — write once, tailor per network.'],
  ['A real content calendar', 'Month, week, day and agenda views. Drag a post to another day and its time moves with it.'],
  ['AI that writes the batch', 'Describe your business and get posts back with captions and images, ready to edit.'],
  ['Bulk upload', 'Queue a month from one spreadsheet instead of posting one at a time.'],
  ['Editing built in', 'Crop to each platform’s required ratio without leaving the app.'],
  ['Link in bio included', 'A hosted page with click analytics and email capture — not a separate subscription.'],
]

/**
 * @param {string} lead - one sentence tying the product to THIS article's problem
 */
export default function ProductBlock ({ lead }) {
  return (
    <section className='my-5 p-4 p-md-5 rounded-3' style={{ background: '#f8fafc', border: '1px solid #e5e7eb' }}>
      <h2 className='fw-bold h4 mb-3'>What is Greatly Social?</h2>

      <p className='text-muted mb-2'>
        Greatly Social is the social media scheduler for people who post to more than one
        place. At Greatly Social you write a post once, adjust it per network, and schedule
        it — and everything you have queued sits on one calendar rather than inside eight
        separate apps.
      </p>

      {lead && <p className='text-muted mb-4'>{lead}</p>}

      <Row className='g-3 mb-4'>
        {PRODUCT_FEATURES.map(([title, body]) => (
          <Col md={6} key={title}>
            <div className='d-flex align-items-start gap-2'>
              <CheckCircleFill className='text-success mt-1 flex-shrink-0' />
              <div>
                <div className='fw-semibold small'>{title}</div>
                <div className='text-muted' style={{ fontSize: 13 }}>{body}</div>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      <Button variant='primary' size='lg' href='/register' className='me-2 mb-2 fw-semibold'>
        Start using Greatly Social free
      </Button>
      <Button variant='outline-secondary' href='/plans' className='mb-2'>
        See plans from $9/month
      </Button>
      <p className='text-muted mb-0 mt-2' style={{ fontSize: 13 }}>
        14-day free trial · no credit card · plans from $9/month
      </p>
    </section>
  )
}
